import { Disclosure } from '@headlessui/react';
import React, { ReactElement, ReactNode } from 'react';
import Text from './text';

interface Props {
  title: string;
  children: ReactNode;
  open?: boolean;
  className?: string;
}

function DisclosureDefault({
  title,
  children,
  open = false,
  className = 'col-span-full lg:col-span-6',
}: Props): ReactElement {
  return (
    <div className={className}>
      <Disclosure defaultOpen={open}>
        <Disclosure.Button className="px-10 py-6 bg-black text-white w-full text-left border-b border-transparent hover:border-telesoft transition duration-300">
          <Text variant="headingLight" className="text-white">
            {title}
          </Text>
        </Disclosure.Button>
        <Disclosure.Panel className="p-10 bg-accent-1">
          {children}
        </Disclosure.Panel>
      </Disclosure>
    </div>
  );
}

export default DisclosureDefault;
